import React, {forwardRef} from 'react';
import "react-datepicker/dist/react-datepicker.css";
//import DatePicker from 'react-datepicker';
//import { getElementId, useWebformElement } from '../utils';
//import WebformElementWrapper from './WebformElementWrapper';
//import Button from "../../../../src/components/button-generic"
import Icon from "../../../../src/components/icon"


const WebFormDatepickerInput = forwardRef(({ value, onClick, name, isRequired, element, onChange, error }, ref) => (

  <div className="form-field">
  <label
    labelFor={name}
    error={error}
  >

  {element?.attributes[0]?.value}
  </label>
  <input
    onClick={onClick}
    onChange={onChange}
    ref={ref}
    className="form-control react-datepicker-ignore-onclickoutside"
    value={value}
    type="text"
    name={name}
    required={isRequired}
   />
   <i className="arrow-down"><Icon
     icon="icons-32-x-32-export-chevron-down-2"
     className="icon"
     size={24}
     color="#ff0"
     style={{ color: '#ff0'}}
     onClick={onClick}
     />
     </i>
  </div>
));
export default WebFormDatepickerInput;
//# sourceMappingURL=WebformDatetime.jsx.map
